import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SaToastComponent } from './shared/components/sa-toast/sa-toast.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SaToastComponent],
  template: `
    <router-outlet />
    <sa-toast />
  `,
})
export class AppComponent {}
